/* global translations */
import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import VipStore from '../../stores/VipStore';
import { VipActionCreators } from '../../actions';
import { Checkbox, Input } from '../../components/forms';
import ImageSvg from '../../components/image/ImageSvg';

class VipSettingsContainer extends Component {
  state = {
    vipOn: VipStore.getVipOn(),
    vipName: VipStore.getVipName(),
    vipIcon: VipStore.getVipIcon(),
    loading: VipStore.getLoading(),
    error: VipStore.getError(),
    errors: VipStore.getErrors(),
  };

  componentDidMount() {
    VipStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    VipStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      vipOn: VipStore.getVipOn(),
      vipName: VipStore.getVipName(),
      vipIcon: VipStore.getVipIcon(),
      loading: VipStore.getLoading(),
      error: VipStore.getError(),
      errors: VipStore.getErrors(),
    });
  };

  onVipOnChange = (e) => {
    VipStore.setVipOn(e.target.checked);
    VipStore.emitChange();
  };

  onVipIconChange = (e) => {
    VipStore.setVipIcon(e.target.checked);
    VipStore.emitChange();
  };

  onVipNameChange = (e) => {
    VipStore.setVipName(e.target.value);
    VipStore.emitChange();
  };

  onSubmit = (e) => {
    e.preventDefault();

    VipStore.setLoading(true);
    VipStore.setError('');
    VipStore.setErrors({});
    VipStore.emitChange();

    VipActionCreators.saveSettings(e.target);
  };

  render() {
    const {
      vipOn,
      vipName,
      vipIcon,
      loading,
      error,
      errors,
    } = this.state;
    const { vipSubscribed } = this.props;

    //
    const hasNameVipErrors = Object.prototype.hasOwnProperty.call(errors, 'name_vip') && errors.name_vip.length;
    const preparedNameVipErrors = () => {
      if (!hasNameVipErrors) {
        return '';
      }

      const nameVipErrors = [];
      errors.name_vip.forEach((err, index) => {
        const key = `error_${index}`;
        nameVipErrors.push(
          <div
            key={key}
          >
            {err}
          </div>,
        );
      });

      return nameVipErrors;
    };

    //
    const errorMessage = () => {
      if (!error) {
        return (null);
      }

      return (
        <div className="mts">
          <div className="message">
            <div className="flash-inner error dib pr twsnw">
              <div className="flash-icon">
                <ImageSvg svg="icon-warning" iconClass="icon--full icon--warning" />
              </div>
              <div className="flash-content mls">{error}</div>
            </div>
          </div>
        </div>
      );
    };

    //
    return (
      <div id="VipSettings" className={loading ? 'loading' : ''}>
        {/* loading && (
          <div className="loading-spinner loading-spinner--vcenter" />
        ) */}
        <div className="twb">{get(translations, 'txt: VIP Uzstādījumi', '')}</div>
        {!vipSubscribed && (
          <div
            className="tss tsi"
            dangerouslySetInnerHTML={{ __html: get(translations, 'txt: * Lai šie uzstādījumi kļūtu pieejami, nepieciešams iegādāties VIP abonementu.', '') }}
          />
        )}
        <form onSubmit={this.onSubmit}>
          <Checkbox
            id="PropertiesVipOn"
            label={get(translations, 'txt: Ieslēgt VIP režīmu', '')}
            onChange={this.onVipOnChange}
            name="properties[vip_on]"
            value={1}
            checked={vipOn}
            disabled={!vipSubscribed}
            labelClass={vipSubscribed ? '' : 'disabled'}
            wrapClass="form-checkbox mtm"
          />
          <Checkbox
            id="PropertiesVipIcon"
            label={get(translations, 'txt:Rādīt PREMIUM ikonu uz profila bildes', 'Rādīt PREMIUM ikonu uz profila bildes')}
            onChange={this.onVipIconChange}
            name="properties[vip_icon]"
            value={1}
            checked={vipIcon}
            disabled={!vipSubscribed}
            labelClass={vipSubscribed ? '' : 'disabled'}
            wrapClass="form-checkbox"
          />
          {errorMessage()}
          <input
            type="submit"
            className={`dib mtm btn btn--a${vipSubscribed ? '' : ' btn--disabled'}`}
            value={get(translations, 'txt: Saglabāt', '')}
            disabled={!vipSubscribed}
          />
        </form>
      </div>
    );
  }
}

VipSettingsContainer.propTypes = {
  vipSubscribed: PropTypes.bool,
};

VipSettingsContainer.defaultProps = {
  vipSubscribed: false,
};

export default VipSettingsContainer;
